module.exports = __webpack_public_path__ + "dimer/static/img/bg.c9bb9ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg.jpg
// module id = dZ/S
// module chunks = 0